<template>
    <div class="warmSet interactionSet">
        <el-form ref="form" :model="form" label-width="90px" class="demo-item" label-position="left" size="mini">
            <el-form-item label="服务号通知">
                <el-switch v-model="form.isnotifybymp" :active-value=1 :inactive-value=0 :disabled="isEnd"></el-switch>
                <span class="tips magin20">开始后直播开始前30分钟关注公众号的微信用户会收到通知</span>
            </el-form-item>
            <el-form-item label="打赏开关">
                <el-switch v-model="form.isopenreward" :active-value=1 :inactive-value=0 :disabled="isEnd"></el-switch>
                <span class="tips magin20">关闭打赏后，直播间打赏将关闭，所有主播均不能获得打赏</span>
            </el-form-item>
            <el-form-item label="" v-show="form.isopenreward">
                <el-radio-group v-model="form.rewardmsgtype" class="hasbgcolor" :disabled="isEnd">
                    <el-radio :label="1">对所有人可见</el-radio>
                    <el-radio :label="2">仅主播和打赏者可见</el-radio>
                </el-radio-group>
                <!--打赏金额设置-->
                <div class="reward_wrap">
                    <p class="title">打赏金额设置 <span>价格为0.00时移动端将不显示该价格</span></p>
                    <div class="reward_box">
                        <div v-if="rewardItem && rewardItem.length>0" class="reward_item" v-for="(item,index) in rewardItem" :key="index">
                            <el-input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" v-model="item.val" placeholder="0.00" :disabled="isEnd" min="0.00" max="200"></el-input>
                            <span class="yuan">元</span>
                        </div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" class="saveBtn" @click="saveEvent" v-if="!isEnd">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {uploadLiveInteractiveSetting} from 'api/vliveV2Api'
    import {mapGetters,mapActions} from 'vuex'
    export default {
        name: "interactionSet",
        data(){
            return{
                rewardItem:[],
                form:{
                    liveid:'', //直播id
                    isnotifybymp:0, //是否打开服务通知
                    isopenreward:0, //是否打开打赏开关
                    rewardmsgtype:1, //打赏结果 1所有人可见 2主播/打赏人可见
                    initrewardmoney:'', //打赏金额
                },
                isEnd:false,
                isMaxVlue:false,
                isMinVlue:false,
            }
        },
        mounted(){
            this.form= JSON.parse(JSON.stringify(this.playInfo.interactioninfo));
            this.rewardItem =[];
            this.form.initrewardmoney.split(',').forEach(item=>{
                this.rewardItem.push({val:item})
            });
            this.isEnd=[10,100].indexOf(this.liveInfo.status)>=0
        },
        methods:{
            //保存
            saveEvent(){
                let arr = [];
                const error = this.rewardItem.some(item => item.val < 0.00 || item.val > 200);
                // const error2 = this.rewardItem.some(item => item.val=Number(item.val.match(/\d+\.?\d{0,2}/)));
                this.form.initrewardmoney = arr.join(',');
                if (error) {
                    return this.$message('打赏金额只能在0~200元')
                }
                // if(error2){
                //     return this.$message('请输入正确的打赏金额')
                // }
                else{
                    let arr = [];
                    this.rewardItem.forEach(item=>{
                        arr.push(item.val)
                    });
                    this.form.initrewardmoney = arr.join(',');
                    this.setLoading(true);
                    uploadLiveInteractiveSetting({
                        data: Object.assign({}, this.form),
                        success: data => {
                            this.setLoading(false);
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            })
                        },
                        error: data => {
                            this.setLoading(false);
                            this.$message.error(data.msg)
                        }
                    })
                }
            },
            ...mapActions([
                'setLoading','setLiveInfo','setPlayInfo'
            ])
        },
        computed: {
            ...mapGetters([
                'liveInfo','playInfo'
            ])
        },
    }
</script>

<style lang="scss">
    .interactionSet{
        .hasbgcolor{
            width: 750px;
            background: rgba(245,247,250,1);
            padding: 15px;
            margin-bottom: 15px;
        }
        .reward_wrap{
            .title{
                padding-bottom: 5px;
                span{
                    color: #999;
                    margin-left: 10px;
                    font-size: 12px;
                }
            }
            .reward_box{
                display: flex;
                flex-wrap: wrap;
                width: 420px;
                .reward_item{
                    width: 115px;
                    height: 36px;
                    line-height: 36px;
                    background:rgba(245,247,250,1);
                    border-radius:1px;
                    display: flex;
                    justify-content: space-between;
                    margin-right: 20px;
                    margin-bottom: 10px;
                    .el-input__inner{
                        border: none;
                        background: none;
                        font-size: 14px;
                        color: #666;
                    }
                    .yuan{
                        padding-right: 10px;
                        color: #C0C4CC;
                        font-size: 14px;
                    }
                }
            }
        }
        .saveBtn{
            margin-top: 0;
        }
    }
</style>
